module.exports = __webpack_public_path__ + "static/fsr-a-490ccd129d586a39dcf36fed01edbd83.png";